<div class="modal-content">
  <div class="modal-header">
    <h4 class="title is-size-4" translate="kws.deactivate.title"></h4>
  </div>
  <div class="modal-body">
    <p class="has-text-grey" translate="kws.deactivate.subtitle"></p>
  </div>
  <div class="modal-footer">
    <div class="is-flex is-centered">
      <button
        [primary]="true"
        type="button"
        class="has-text-weight-bold mr-1"
        (click)="submit()"
        fino-button
        label="kws.deactivate.submit"
      ></button>

      <button
        type="button"
        (click)="abort()"
        class="ml-1"
        fino-button
        label="kws.deactivate.abort"
      ></button>
    </div>
  </div>
</div>
